import { render, staticRenderFns } from "./ChatsLeadsIndex.vue?vue&type=template&id=42d422ca&"
import script from "./ChatsLeadsIndex.vue?vue&type=script&lang=js&"
export * from "./ChatsLeadsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports